import { SITECORE_PAGES } from 'core/constants';

import {
	getLocalStorageItem,
	setLocalStorageItem,
	removeLocalStorageItem,
} from './localStorage';

const lastUrlAccessKeyName = 'LastUrlAccess';

export const getLastUrlAccess = (): string => {
	const accessToken = getLocalStorageItem(lastUrlAccessKeyName);

	return accessToken;
};

export const setLastUrlAccess = (tokenValue: string) => {
	// Save the dashboard URL in local storage, in case of outage dashboard,
	// we want to save the BAU dashboard URL instead to ensure users can be redirected to BAU dashboard when outage mode is off
	const itemValue =
		tokenValue === SITECORE_PAGES.OUTAGE_DASHBOARD
			? SITECORE_PAGES.DASHBOARD
			: tokenValue;
	setLocalStorageItem(lastUrlAccessKeyName, itemValue);
};

export const removeLastUrlAccess = () => {
	removeLocalStorageItem(lastUrlAccessKeyName);
};
